<!-- messenger.com STYLE -->
<script>
export let message;

</script>


<style>

.flash-message {
	border-radius: 0.25rem;
	background: #242424;
	width: 100%;
	margin-top: 0.75rem;
	padding: 1.25rem 1.5rem;
}

p {
	font-size: 0.95rem;
}

.error p {
	color: #f36868;
}

.success p {
	color: #eee;
}

</style>


<div class="flash-message {message.type}">

	<p>
		{message.msg}
	</p>

</div>
